import { render } from "./index.vue?vue&type=template&id=2e261f1f&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=2e261f1f&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2e261f1f&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e261f1f"]])

export default __exports__